// src/components/SignupModal.tsx
import React, { useState, useEffect } from 'react';
import SignupPage from '../pages/auth/SignupPage';
import LoginPage from '../pages/auth/LoginPage';
import './FlipAnimation.css'; 
import LoginSignupLayout from './LoginSignupLayout';

interface SignupModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialView?: 'login' | 'signup';
  initialUserType?: 'buyer' | 'seller';
}

const SignupModal: React.FC<SignupModalProps> = ({ isOpen, onClose, initialView = 'signup', initialUserType = 'buyer' }) => {
  const [showLogin, setShowLogin] = useState(initialView === 'login');
  const [isFlipped, setIsFlipped] = useState(false);
  const [userType, setUserType] = useState<'buyer' | 'seller'>(initialUserType);

  useEffect(() => {
    if (isOpen) {
      setShowLogin(initialView === 'login');
      setIsFlipped(initialView === 'login');
      setUserType(initialUserType);
    }
  }, [isOpen, initialView, initialUserType]);

  if (!isOpen) return null;

  const handleShowLogin = () => {
    setIsFlipped(true);
    setTimeout(() => setShowLogin(true), 300); 
  };

  const handleShowSignup = () => {
    setIsFlipped(false);
    setTimeout(() => setShowLogin(false), 300);
  };

  const handleLoginSuccess = () => {
    onClose();
  };

  return (
    // FIX: 'z-[9999]' to ensure it stays on top of everything.
    // 'p-4' added so it doesn't touch screen edges on mobile.
    <div className="fixed inset-0 z-[9999] bg-gray-900 bg-opacity-60 backdrop-blur-sm flex items-center justify-center p-4">
      
      {/* FIX: 
          1. h-[550px]: Fixed height thodi badhayi taaki form fit ho.
          2. max-h-[90vh]: Agar screen choti hai toh screen ke hisaab se height lega (katega nahi).
          3. overflow-hidden: Corners rounded rahenge.
      */}
      <div className="relative w-full max-w-4xl h-[550px] max-h-[90vh] perspective-1000 shadow-2xl rounded-xl">
        
        <LoginSignupLayout currentUserType={userType} onUserTypeChange={setUserType}> 
          <div className={`modal-flipper w-full h-full ${isFlipped ? 'flipped' : ''}`}>
            
            {/* Front Side - Signup Page */}
            <div className="modal-front absolute w-full h-full bg-white flex flex-col">
              <button onClick={onClose} className="absolute top-2 right-4 text-gray-400 hover:text-red-500 text-3xl z-20 font-light">&times;</button>
              <SignupPage onShowLogin={handleShowLogin} initialUserType={userType} />
            </div>

            {/* Back Side - Login Page */}
            <div className="modal-back absolute w-full h-full bg-white flex flex-col">
              <button onClick={onClose} className="absolute top-2 right-4 text-gray-400 hover:text-red-500 text-3xl z-20 font-light">&times;</button>
              <LoginPage 
                onShowSignup={handleShowSignup} 
                onLoginSuccess={handleLoginSuccess} 
                initialUserType={userType} 
              />
            </div>

          </div>
        </LoginSignupLayout>
      </div>
    </div>
  );
};

export default SignupModal;